
<div class="popover shadow fade show bs-popover-bottom" (clickOutside)="onClickedOutside(assignment)"
     role="tooltip"
     x-placement="bottom"
     *ngIf="assignment$ | async as assignment">
  <div class="arrow"
       style="left: 114px;"></div>

  <h3 class="popover-header d-flex justify-content-between">
    {{ assignment?.domainTitle }}

    <a (click)="close();">
      <span class="mdi mdi-close"></span>
    </a>

  </h3>
  <div class="popover-body">
    <p>{{ assignment?.learningObjectiveTitle }}</p>
    <button (click)="showDetails(assignment?.id)"
            class="btn btn-primary btn-block mb-3">{{ 'BUTTON_DETAILS' | translate }}</button>
    <app-status-button-group>
    </app-status-button-group>
  </div>
</div>